import { render, staticRenderFns } from "./video.vue?vue&type=template&id=f4d9832a&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=f4d9832a&lang=css&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&id=f4d9832a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9832a",
  null
  
)

export default component.exports